import { Component, createSignal } from "solid-js";
import DefaultAcordeon from "./DefaultAcordeon";
import Styles from "bundle-text:../styles/_selectWebsite.scss";
import { translations as t } from "../../../services/context";

interface SelectWebsiteProps {
  onSelect: (website: string) => void;
  websites: string[];
  totalWebsites: number;
}

const SelectWebsite: Component<SelectWebsiteProps> = (props) => {
  const [selectedWebsite, setSelectedWebsite] = createSignal<string | null>(
    null
  );
  const handleSelect = (website: string) => {
    setSelectedWebsite(website);
    props.onSelect(website);
  };

  return (
    <>
      <style>{Styles}</style>
      <DefaultAcordeon title={t["dns_select_website"]} isOpen={true}>
        <div class="select-website-header">
          <p>{t["dns_your_website"]}</p>
          <builderall-icon code="funnel"></builderall-icon>
          <span>
            {props.websites.length} {t["dns_general_of"]} {props.totalWebsites}
          </span>
          <div className="with-button">
            <input type="text" placeholder="Search" />
            <button>
              <builderall-icon code="search"></builderall-icon>
            </button>
          </div>
        </div>
        <ul class="select-website-list">
          {props.websites.map((website) => (
            <li onClick={() => handleSelect(website)}>
              <input
                type="radio"
                name="website"
                checked={selectedWebsite() === website}
              />
              <span>{website}</span>
            </li>
          ))}
        </ul>
        <nav className="select-website-navigation">
          <ul>
            <li className="active">1</li>
            <li>2</li>
            <li>3</li>
            <li className="ellipsis">...</li>
            <li>4</li>
            <li>5</li>
            <li>6</li>
          </ul>
        </nav>
      </DefaultAcordeon>
    </>
  );
};

export default SelectWebsite;
